import { array } from 'fp-ts';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';

export const useGetSelectedSettlementRules = (selectedSettlementRuleIds: string[]) =>
    useRepositoryQuery(
        'settlementRules',
        'getAll',
        { enterpriseId: useCurrentEnterpriseId() },
        {
            select: (result) =>
                array.isNonEmpty(result) ? result.filter(({ id }) => selectedSettlementRuleIds.includes(id)) : [],
        }
    );
